import { createFileRoute } from "@tanstack/react-router"
import { createProjectViewStaticData } from "src/views/CreateProjectView/constants"
import { CreateProjectView } from "src/views/CreateProjectView/CreateProjectView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/settings/projects/create")({
	component: CreateProjectView,
	staticData: createProjectViewStaticData,
})
